// @ts-ignore
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({ trickleSpeed: 100 });

export default NProgress;
